import { useMediaQuery, useTheme } from "@mui/material";
import type { ModalComponentProps } from "../../../types/modal.types";
import Modal from "../base.modal";
import PdfViewer from "../../ui/file/pdf-viewer";
import Button from "../../ui/button";

interface PrioAuthorizationModalProps extends ModalComponentProps {
  priorAuthorizationUri: string;
}

const PrioAuthorizationModal = ({
  onClose,
  priorAuthorizationUri,
}: PrioAuthorizationModalProps) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Modal size={isSmallScreen ? "mobile" : "default"} close={onClose}>
      <div className="px-6 py-4">
        <p className="text-[20px] font-medium">사전승낙서</p>
      </div>
      <div className="px-6 py-4">
        <div className="w-full">
          <div className="max-h-[calc(80vh)] overflow-auto">
            <PdfViewer file={priorAuthorizationUri} />
          </div>
        </div>
      </div>
      <div className="flex justify-end p-2">
        <Button variant="outline" label="취소" onClick={onClose} />
      </div>
    </Modal>
  )
}

export default PrioAuthorizationModal
